/** 格式化倒计时 */
export const formattCountdown = (countdown: number) => {
  const hours = Math.floor(countdown / 3600)
  if (hours > 0) {
    const minutes = Math.floor((countdown % 3600) / 60)
    const seconds = countdown % 60
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }
  const minutes = Math.floor(countdown / 60)
  const seconds = countdown % 60
  return `00:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
